import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { ServicePracticesModel } from '@/models/tables/service-practices.model';
import { ServicePracticesService } from '@services/data-source-tables/service-practices.service';
import { DialogServicePracticeComponent } from '@pages/tables/service-practices/dialog-service-practice/dialog-service-practice.component';

@Component({
  selector: 'app-button-detail-service-practice',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDetailServicePracticeComponent extends ButtonComponent implements OnInit {
  faIcon = faPenToSquare;
  private dialogOpened: MatDialogRef<any>;
  private servicePracticesModel: ServicePracticesModel;
  private rowData: any;

  constructor(
    protected router: Router,
    protected toastr: ToastrService,
    protected servicePracticesService: ServicePracticesService,
    private dialog: MatDialog,
  ) {
    super(router, toastr);

    this.showIcon = true;
    this.additionalClass = 'py-0.5 px-2.5';
    this.toolTip = 'Dettaglio Servizio pratica';
    this.smallBtn = true;
  }

  ngOnInit() {
    this.servicePracticesModel = <ServicePracticesModel>this.rowData;
  }

  /**
   * Open modal new detail page
   */
  public actionClick(): void {
    this.dialogOpened = this.dialog.open(DialogServicePracticeComponent, {
      data: this.servicePracticesModel,
    });

    Registry.getInstance().set('DialogServicePracticeComponentModify', this.dialogOpened);
  }
}
